export default [
  {
    path: '/admin/announce/more',
    name: 'M020051',
    component: () => import('@/views/admin/main/components/announce/Main.vue'),
    meta: { layout: 'admin', title: '资讯公告' },
  },
  // {
  //   path: '/admin/service/more', // 已弃用
  //   name: 'M020053',
  //   component: () => import('@/views/admin/main/components/service/Main.vue'),
  //   meta: { layout: 'admin', title: '服务中心' },
  // },
  {
    path: '/admin/service/my-service-list',
    name: 'M020053',
    component: () =>
      import('@/views/admin/main/components/service/MyServiceList.vue'),
    meta: { layout: 'admin', title: '服务中心' },
  },
  {
    path: '/admin/schedule/more',
    name: 'M020054',
    component: () => import('@/views/admin/main/components/schedule/Main.vue'),
    meta: { layout: 'admin', title: '个人日程' },
  },
  {
    path: '/admin/message/more',
    name: 'M020052',
    component: () => import('@/views/admin/main/components/message/Main.vue'),
    meta: { layout: 'admin', title: '消息中心' },
  },
  // {
  //   path: '/admin/message/more',
  //   name: 'M020056',
  //   component: () => import('@/views/admin/main/components/message/Main.vue'),
  //   meta: { layout: 'admin', title: '工作事项' },
  // },
];
